export default {
    
    find:   { method: 'get',    url: 'resource_types' },
    create: { method: 'post',   url: 'resource_types'},
    update: { method: 'put',    url: 'resource_types/{id}'},
    delete: { method: 'delete', url: 'resource_types/{id}'}
}